import DialogShare from '~/components/dialog/share/DialogShare.vue';
const { share, isSupported: isShareSupported } = useShare();
export const useShareNomad = (shareText?: string, close?: Function) => {
  const { t } = useI18n();

  const shareTextUsed = computed(() => {
    if (shareText) return shareText;
    return t('share.nomad');
  });

  const dialog = useDialogStore();

  const handleShare = () => {
    if (!isShareSupported.value) {
      dialog.open(DialogShare, {
        iconHeader: 'share',
        title: "Partager l'application",
        label: '',
        shareText: shareTextUsed.value,
        onClose: () => {
          if (close) close();
        },
      });
    } else {
      share({
        text: shareTextUsed.value,
      });
    }
  };
  return {
    handleShare,
  };
};
